import { mockBuilder } from '../utils/builderHelper.es.js';
import '../enums/billing/AccountGlobalStatusEnum.es.js';
import '../enums/billing/AccountingStatusEnum.es.js';
import '../enums/billing/AssetPurchaseFormatEnum.es.js';
import '../enums/billing/AssetPurchaseUnavailableCodeEnum.es.js';
import '../enums/billing/BillingSystemEnum.es.js';
import '../enums/billing/CreditKindEnum.es.js';
import '../enums/billing/InvoiceStatusEnum.es.js';
import '../enums/billing/DiscountTypeEnum.es.js';
import '../enums/billing/PlanFrequencyEnum.es.js';
import '../enums/billing/ServiceOffersKindEnum.es.js';
import '../enums/billing/ServiceStatusEnum.es.js';
import '../enums/billing/SubscriptionStatusEnum.es.js';
import '../enums/billing/SubscriptionMigrationTypeEnum.es.js';
import '../enums/billing/SubscriptionMigrationTimingEnum.es.js';
import '../enums/billing/SubscriptionServiceOfferEnum.es.js';
import '../enums/billing/BillingCommitmentEnum.es.js';
import '../enums/collaboration/ActorEnum.es.js';
import '../enums/collaboration/EntityTypeEnum.es.js';
import '../enums/AppHomePageEnum.es.js';
import '../enums/ApplicationEnum.es.js';
import '../enums/CreditCardEnum.es.js';
import '../enums/DollarSignCurrenciesEnum.es.js';
import '../enums/DownloadBinStatusEnum.es.js';
import '../enums/ExternalTypeEnum.es.js';
import '../enums/FeatureEnum.es.js';
import '../enums/FeatureFlagEnum.es.js';
import '../enums/FileSelectionSourceEnum.es.js';
import '../enums/GenresEnum.es.js';
import { IntensityEnum } from '../enums/IntensityEnum.es.js';
import '../enums/InternalErrorEnum.es.js';
import '../enums/LibraryItemEnum.es.js';
import { MasteringStyleEnum } from '../enums/MasteringStyleEnum.es.js';
import '../enums/MfeApplicationEnum.es.js';
import '../enums/NotificationTypeEnum.es.js';
import '../enums/PaymentCycleEnum.es.js';
import '../enums/PaymentMethodEnum.es.js';
import '../enums/ProofOfRightsEnums.es.js';
import '../enums/RegexPatternsEnum.es.js';
import '../enums/ReleaseContributorRoleEnum.es.js';
import '../enums/ReleaseGlobalStateEnum.es.js';
import '../enums/ReleaseLanguagesEnum.es.js';
import '../enums/ReleasePayoutStatusEnum.es.js';
import '../enums/ReleasePayoutGlobalStatusEnum.es.js';
import '../enums/ReleaseStateEnum.es.js';
import '../enums/ServiceProviderStateEnum.es.js';
import '../enums/ReleaseStoreCategoryEnum.es.js';
import '../enums/ReleaseStoreEnum.es.js';
import '../enums/ReleaseTerritoriesEnum.es.js';
import '../enums/ReleaseParentalWarningEnum.es.js';
import '../enums/SessionFlagsEnum.es.js';
import '../enums/ShareReactionTypeEnum.es.js';
import '../enums/SocialNetworksEnum.es.js';
import { StatePendingEnum } from '../enums/StateEnum.es.js';
import '../enums/TrackTypeEnum.es.js';
import '../enums/UnavailabilityEnum.es.js';
import '../enums/UserInteractionSourceEnum.es.js';
import '../enums/ZeroDecimalCurrenciesEnum.es.js';
import '../enums/NoiseReductionLevelEnum.es.js';
import '../enums/ReleaseDspsEnum.es.js';
import '../enums/ReleaseDspStatusEnum.es.js';
import '../enums/ProjectsCallSourceTypesEnum.es.js';
import '../enums/LibraryItemTypeEnum.es.js';
import '../enums/PendingItemStateEnum.es.js';
import '../enums/MonetizationEligibilityStateEnum.es.js';
import '../enums/CoverSongOptionsEnum.es.js';
import '../enums/LanguagesEnum.es.js';
import '../enums/LocalesEnum.es.js';
import { PreviewIntensity, Preview } from './Preview.es.js';
import { anAudioStreamFile } from './StreamFile.mock.es.js';
import { aState } from './State.mock.es.js';

/** @module Mocks */ /** typedoc */
/**
 * Create a PreviewIntensity
 * @returns { PreviewIntensity }
 */
function aPreviewIntensity() {
    return mockBuilder(new PreviewIntensity())
        .withIntensity(IntensityEnum.High)
        .withStyle(MasteringStyleEnum.Balanced)
        .withStream(anAudioStreamFile()
        .withMp3Uri('https://s3.amazonaws.com/mobile.landr.app/albums/3tracks_mastered_192k.mp3')
        .withMp4Uri(undefined)
        .withOggUri('https://s3.amazonaws.com/mobile.landr.app/albums/3tracks_mastered_192k.ogg'))
        .withVolumeRatio(0.5);
}
/**
 * Create a New Preview
 * @returns { Preview }
 */
function aPreview() {
    return mockBuilder(new Preview())
        .withCreationState(aState().withName(StatePendingEnum.Available).withProgress(100))
        .withDefaultIntensity(IntensityEnum.Medium)
        .withDefaultStyle(MasteringStyleEnum.Balanced)
        .withEstimatedTimeToCompletionInMS(120000)
        .withOriginalStream(anAudioStreamFile()
        .withMp3Uri('https://s3.amazonaws.com/mobile.landr.app/albums/3tracks_original_192k.mp3')
        .withMp4Uri(undefined)
        .withOggUri('https://s3.amazonaws.com/mobile.landr.app/albums/3tracks_original_192k.ogg'))
        .withIntensities([
        aPreviewIntensity().withIntensity(IntensityEnum.Low),
        aPreviewIntensity().withIntensity(IntensityEnum.Medium),
        aPreviewIntensity().withIntensity(IntensityEnum.High),
    ])
        .withEngineVersion('mock_engine_version');
}
function aPreviewWithAdvancedMasteringPresets() {
    return aPreview()
        .withDefaultIntensity(IntensityEnum.High)
        .withDefaultStyle(MasteringStyleEnum.Warm)
        .withIntensities([
        aPreviewIntensity().withIntensity(IntensityEnum.Low).withStyle(MasteringStyleEnum.Warm),
        aPreviewIntensity().withIntensity(IntensityEnum.Low).withStyle(MasteringStyleEnum.Balanced),
        aPreviewIntensity().withIntensity(IntensityEnum.Low).withStyle(MasteringStyleEnum.Open),
        aPreviewIntensity().withIntensity(IntensityEnum.Medium).withStyle(MasteringStyleEnum.Warm),
        aPreviewIntensity().withIntensity(IntensityEnum.Medium).withStyle(MasteringStyleEnum.Balanced),
        aPreviewIntensity().withIntensity(IntensityEnum.Medium).withStyle(MasteringStyleEnum.Open),
        aPreviewIntensity().withIntensity(IntensityEnum.High).withStyle(MasteringStyleEnum.Warm),
        aPreviewIntensity().withIntensity(IntensityEnum.High).withStyle(MasteringStyleEnum.Balanced),
        aPreviewIntensity().withIntensity(IntensityEnum.High).withStyle(MasteringStyleEnum.Open),
    ]);
}

export { aPreview, aPreviewIntensity, aPreviewWithAdvancedMasteringPresets };
